import React from 'react'
import styled from '@emotion/styled'
import { colors, font, radius, shadow, spacing } from '@mobi/component-library/Foundations'

export const CardContainer = React.forwardRef<
  HTMLDivElement,
  { headerSection: React.ReactNode; children: React.ReactNode }
>(({ headerSection, children }, ref) => (
  <CardContainerStyled ref={ref}>
    {headerSection}

    <div>{children}</div>
  </CardContainerStyled>
))

CardContainer.displayName = 'CardContainer'

// ======
// Styles
// ======

const CardContainerStyled = styled.article({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: colors.white,
  boxShadow: shadow.sm,
  borderRadius: radius.lgx2,
  border: `1px solid ${colors.neutral[200]}`,
  fontFamily: font.family.primary,
  padding: `0 0 ${spacing.sm} 0`,

  '> div': {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.smx1,
    padding: `0 ${spacing.sm}`,
  },
})
